import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-organization-content',
    templateUrl: './organization-content.component.html',
    styleUrls: ['./organization-content.component.scss'],
})
export class OrganizationContentComponent {
    flag = false;
    constructor(private router: Router) {}

    navigateToInstance() {
        if (localStorage.getItem('selectedOrgId')) {
            this.router.navigate(['/management/instance'], { queryParams: { organizationId: `${localStorage.getItem('selectedOrgId')}` } });
        }
    }
}
